import _ from 'lodash'
import moment from 'moment'
import { useEffect } from 'react'

import { CircularProgress } from '../../shared/NarusMaterial'
import { humanName } from '../utils'

import Message from './message'

const MessageGroup = ({ clientName, chat, group, date, tagsSetting, currentUserId, getUrlPreview }) => {
  const namesIdx = {}

  const renderMessage = m => {
    const {
      id,
      meta: { patient_id: patientId, forParticipant },
      participants
    } = chat

    const [ authorRole, authorId ] = m.author.split('/')
    let authorName = namesIdx[authorId]
    if (!authorName) {
      const participant = participants.find(pt => pt.id === authorId)
      if (participant) {
        const name = humanName(participant.name)
        authorName = (participant.active && name) || `${name} (inactive)`
      } else {
        authorName = 'Unknown Person'
      }
      namesIdx[authorId] = authorName
    }

    if (m.concierge) {
      authorName = humanName(m.concierge.name)
    }

    const isMyMessage = forParticipant === m.author
    const isPractitionerMessage = authorRole === 'Practitioner'

    let messageOwner = 'patient'

    if (isMyMessage) {
      messageOwner = 'my'
    } else if (isPractitionerMessage) {
      messageOwner = 'practitioner'
    }

    const userIdForAttachment = forParticipant
      ? forParticipant.split('/')[1]
      : currentUserId

    return (
      <Message
        key={m.id}
        message={m}
        displayName={participants.length > 2 || chat.meta.concierge}
        authorName={authorName}
        getUrlPreview={getUrlPreview}
        userIdForAttachment={userIdForAttachment}
        tagsSetting={tagsSetting}
        messageOwner={messageOwner}
        clientName={clientName}
        patientId={patientId}
        chatId={id}
      />
    )
  }

  return (
    <div className='chat_message_group'>
      <div className='chat_message_group_date'>
        <span>{moment(date).format('MM/DD/YYYY')}</span>
      </div>
      {group.map(m => renderMessage(m))}
    </div>
  )
}

const ChatBody = ({
  chat,
  currentUserId,
  onMoreHistory,
  clientName,
  messagesLoading,
  tagsSetting,
  bottomAnchorRef,
  bodyRef,
  locationKey,
  getUrlPreview
}) => {
  // useEffect(() => {
  //   onMoreHistory()
  // }, [ chat.id, onMoreHistory ])

  const scrollToMessageId = messagesLength => {
    const chatOffset = chat.chat_offset
    const scrollTo =
      chatOffset - messagesLength > 20 ? 20 : chatOffset - messagesLength
    const message = chat.messages?.[scrollTo]?.id
    const node = document.getElementById(message)
    node?.scrollIntoView()
  }

  const scrollHandler = () => {
    const messagesLength = chat?.messages?.length
    if (
      bodyRef.current?.scrollTop <= 0 &&
      _.get(chat.messages, [ 0, 'chat_offset' ]) !== 1
    ) {
      onMoreHistory().then(() => scrollToMessageId(messagesLength))
    }
  }

  useEffect(() => {
    if (chat?.messages?.length <= 20) {
      const scrollTo =
        bottomAnchorRef?.current?.offsetTop - bodyRef?.current?.scrollTop
      bodyRef?.current?.scrollBy({
        top: scrollTo,
        left: 0
      })
    }
  }, [ bodyRef, bottomAnchorRef, chat?.messages ])

  useEffect(() => {
    if (chat?.messages) {
      const scrollTo =
        bottomAnchorRef?.current?.offsetTop - bodyRef?.current?.scrollTop
      bodyRef?.current?.scrollBy({
        top: scrollTo,
        left: 0
      })
    }
  }, [ bodyRef, bottomAnchorRef, chat?.messages, locationKey ])

  const getDate = createdAt => {
    return createdAt?.split('T')?.[0]
  }

  const chatMessagesGroup = chat?.messages?.reduce((acc, m) => {
    const date = getDate(m.created_at)
    if (acc[date]) {
      acc[date].push(m)
    } else {
      acc[date] = [ m ]
    }
    return acc
  }, {})

  if (messagesLoading) {
    return (
      <div className='no-data-chat'>
        <CircularProgress color='purple' />
      </div>
    )
  }

  return (
    <div
      id='scroll'
      className='chat-body'
      ref={bodyRef}
      key={chat.id}
      onScroll={scrollHandler}
    >

      {Object.keys(chatMessagesGroup || []).length > 0 &&
        Object.keys(chatMessagesGroup).map(date => (
          <MessageGroup
            key={date}
            date={date}
            currentUserId={currentUserId}
            tagsSetting={tagsSetting}
            chat={chat}
            clientName={clientName}
            group={chatMessagesGroup[date]}
            getUrlPreview={getUrlPreview}
          />
        ))}
      <div ref={bottomAnchorRef} />
    </div>
  )
}

export default ChatBody
